export default "__VITE_ASSET__6GRyPSQr__"